import { render, staticRenderFns } from "./UrineViewComponent.vue?vue&type=template&id=c995c67c"
import script from "./UrineViewComponent.vue?vue&type=script&lang=js"
export * from "./UrineViewComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports